import { action, atom } from "@reatom/core"
import { is } from "superstruct"
import { onConnect } from "@reatom/hooks"

import { CatalogSearchQuery, defaultQuery } from "modules/PsyCatalog/common/searchQuery"
import { ctx } from "modules/PsyCatalog/common/ctx"
import { competences } from "modules/PsyCatalog/common/searchQuery/schema"
import { createList } from "modules/PsyCatalog/common/models/utils"
import { Services } from "modules/PsyCatalog/common/services"
import { competencesFetcher } from "modules/PsyCatalog/common/models/competences/competencesFetcher"
import { competencesSlugsAtom } from "modules/PsyCatalog/common/models/competences/competencesSlugsAtom"

export function competencesField({
    UpdateUrl,
    CurrentQuery,
    CurrentFilter,
    FieldStatus,
}: Services) {
    const inputValue = atom<CatalogSearchQuery["competences"]>(CurrentQuery.get().competences)
    const update = action((ctx, value: CatalogSearchQuery["competences"][number]) => {
        inputValue(ctx, (values) => {
            const { toggle } = createList(values)
            return toggle(value)
        })
    })
    const setValue = action((ctx, value: CatalogSearchQuery["competences"]) => {
        inputValue(ctx, value)
    })

    function onChange(value: CatalogSearchQuery["competences"][number]) {
        update(ctx, value)
        UpdateUrl.run()
    }

    function parseValue(value: unknown) {
        return is(value, competences) ? value : defaultQuery.competences
    }

    function parseAndUpdate(value: unknown) {
        setValue(ctx, parseValue(value))
    }

    onConnect(inputValue, () => {
        ctx.subscribe(competencesSlugsAtom, (slugs) => {
            if (slugs.size === 0) return
            const { list } = ctx.get(competencesFetcher.dataAtom)
            for (const slug of slugs.keys()) {
                if (slug && CurrentFilter.get().includes(slug)) {
                    const selected = list.find((competence) => competence.slug === slug)
                    selected && update(ctx, selected.id)
                    FieldStatus.setReady("competences")
                    return
                }
            }
            setValue(ctx, CurrentQuery.get().competences)
            FieldStatus.setReady("competences")
        })
    })
    return { inputValue, onChange, update, parseValue, parseAndUpdate }
}
